import _fetch from '.'

export async function getAllFines(filters, options = {}) {
    const { afm: taxid, status, title } = filters

    const url = new URL(`${process.env.REACT_APP_API_URL}/kok-fines`)

    url.searchParams.set('taxid', taxid)
    url.searchParams.set('status', status)
    url.searchParams.set('title', title)

    return _fetch(url, options)
}

export async function getKokFine(kokFineId, options = {}) {
    const url = `${process.env.REACT_APP_API_URL}/kok-fines/${kokFineId}`
    return _fetch(url, options)
}

export async function createKokFine(options = {}) {
    const url = `${process.env.REACT_APP_API_URL}/kok-fines`
    return _fetch(url, options)
}

export async function updateKokFine(kokFineId, options = {}) {
    const url = `${process.env.REACT_APP_API_URL}/kok-fines/${kokFineId}`
    return _fetch(url, options)
}

export async function getCurrentUserFines(userId, options = {}) {
    const url = `${process.env.REACT_APP_API_URL}/users/${userId}/kok-fines`
    return _fetch(url, options)
}
